import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import ModalPopup from '../common/ModalPopup';

const YourRank = (props) => {
    const resultDetail = props.resultDetail.summary !== undefined && props.resultDetail.summary;
    const detail = props.detail !== undefined && props.detail

    return (
        <>
        {props.title && 
        <div className='widget_title d-flex align-items-center justify-content-between'>
        <h3>Your Rank</h3>
        {/* <span className='tool_tip tooltip_rank'>dsfdfsds</span> */}
        <FontAwesomeIcon icon={faInfoCircle} className="show_tooltip" data-bs-toggle="modal" data-bs-target="#your-rank-info"/>
        </div>
        }

        <div className='rank_Wrapper_contain'>
            <div className='rank_item'>
                <h3>{resultDetail.overseas_rank!==undefined&& resultDetail.overseas_rank ? resultDetail.overseas_rank:''}</h3>
                <h5 className='rank_title'>Overseas Rank</h5>
            </div>
            {detail.class_id !==7 && detail.class_id !==10 ?
            <div className='rank_item'>
                <h3>{resultDetail.india_rank!==undefined && resultDetail.india_rank ? resultDetail.india_rank :''}</h3>
                <h5 className='rank_title'>All India Rank</h5>
            </div>
            :''
            }
            <div className='rank_item'>
                <h3>{resultDetail.country_rank!==undefined&& resultDetail.country_rank}</h3>
                <h5 className='rank_title'>Country Rank ({detail.country})</h5>
            </div>
        </div>

        <ModalPopup id="your-rank-info" size="modal-sm" className="termsConditonsPopup" modalTitle="Your Rank" >
                <p>Your Overseas rank is amongst the same class students who sat for TALLENTEX 2023 from Overseas which includes students from Bahrain, Kuwait, Oman, Qatar, Saudi Arabia and United Arab Emirates</p>
<p>Your Indian rank is a projected rank based on students who sat for TALLENTEX 2023 in the online mode conducted for Indian students taking into consideration the normalization for the difficulty level of both the exams</p>
          </ModalPopup>
        </>
    );
}

export default YourRank